import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//

import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import ButtonMain from "../../../../../../common/components/button/ButtonMain";
import { StoreContext } from "../../../../../../store/StoreProvider";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import urls from "../../../../../../api/project/ApiUrls";
import useModulePublic from "../../../../../hooks/useModulePublic";
import fireAuth from "../../../../../../api/firebase/auth/utils";
import Act from "../../../../../../store/actions";
//
import {
  saveFilterToolSetting,
  resetFilterToolSetting,
  isChanged,
} from "../../settingControl/useSetting";
import { MODULE_ID } from "../../../../../../config/CONSTANTS";

const BottomPanel = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { filter } = sna;
  const { filterEventTypeOn, nodeCountMeetAuthNew } = filter;
  // local state

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  const dataChanged = isChanged(filter);
  // 開啟事件類別的狀態是否變更:開啟事件類別的狀態不能使用 isChanged 方法來判斷,故另外判斷
  const filterEventTypeChanged =
    filterEventTypeOn.initial !== filterEventTypeOn.change;
  // 節點大小為與作者的見面次數
  const isNodeCountMeetAuthChange =
    nodeCountMeetAuthNew.initial !== nodeCountMeetAuthNew.change;
  const disabledApplyBtn =
    !dataChanged && !filterEventTypeChanged && !isNodeCountMeetAuthChange;
  const disabledClearBtn =
    !dataChanged && !filterEventTypeChanged && !isNodeCountMeetAuthChange;
  const showClearSetting = handlePublic(MODULE_ID.snaSidebarFilterClearSetting);

  const getApplyBtnSx = () => {
    if (disabledApplyBtn) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const getClearBtnSx = () => {
    if (disabledClearBtn) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const applySetting = () => {
    // console.log("applySetting filter");
    saveFilterToolSetting(state, dispatch);
  };

  const clearSetting = () => {
    // console.log("clearSetting filter");
    resetFilterToolSetting(state, dispatch);
  };

  return (
    <Box my={4}>
      <Box mb={2}>
        <ButtonMain
          buttonProps={{
            text: intl.formatMessage({
              id: "sna.sidebar.filtertool.bottompanel.apply.setting",
              defaultMessage: "套用條件",
            }),
            fullWidth: true,
            onClick: applySetting,
            disabled: disabledApplyBtn,
            variant: disabledApplyBtn ? "disabled" : null,
            sx: { ...getApplyBtnSx() },
          }}
        />
      </Box>
      {showClearSetting && (
        <Box mb={2}>
          <ButtonMain
            buttonProps={{
              text: intl.formatMessage({
                id: "sna.sidebar.filtertool.bottompanel.clear.setting",
                defaultMessage: "清除條件",
              }),
              fullWidth: true,
              onClick: clearSetting,
              disabled: disabledClearBtn,
              variant: disabledClearBtn ? "disabled" : "clear",
              sx: { ...getClearBtnSx() },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default BottomPanel;
